import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { resourcesRoutes } from '../../routes';

export const Resources: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthed } = useSelector((state: any) => state.authentication);

  useEffect(() => {
    if (!isAuthed) {
      navigate('/', { replace: true });
    }
  }, [navigate]);

  return (
    <div className="practice-admin-dashboard">
      <Routes>
        <Route
          index={true}
          element={<Navigate to="support-options" replace={true} />}
        />

        {resourcesRoutes?.map(route => (
          <Route
            path={route.path}
            element={<route.component />}
            key={route.path}
          />
        ))}
      </Routes>
    </div>
  );
};
